__turbopack_context__.v({
  "textarea": "Textarea-module-scss-module__z3aOgW__textarea",
  "textareaError": "Textarea-module-scss-module__z3aOgW__textareaError",
  "textareaLabel": "Textarea-module-scss-module__z3aOgW__textareaLabel",
});
